








































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import FormItem from '@/components/Money/FormItem.vue';
import Button from '@/components/Button.vue';
import clone from '@/lib/clone';
import dayjs from 'dayjs';

@Component({
    components: {Button, FormItem: FormItem}
})

export default class EditLabels extends Vue {
    tag?: { id: number; name: string } = undefined;
    Record: RecordItem = {
        notes: '',
        tags: [],
        type: '+',
        amount: 0,
        date: '',
        amountToString: '',
        id: 0

    };

    goback() {
        console.log('111');
        this.$router.back();
    }

    get Time() {
        return dayjs(this.Record.date).format('YYYY年MM月DD日 HH:mm');
    }

    created() {
        const id = this.$route.params.id;
        this.$store.commit('fetchRecords');
        const Records: RecordItem[] = clone(this.$store.state.RecordList);
        const i = Records.filter(item => {
            if(item.id){
                return item.id.toString() === id;

            }

        });
        if (i.length > 0) {
            this.Record = i[0];

        }
        console.log(id);
        console.log(i);

    }

}
